export enum FileQualityResource {
  Small = "Small",
  Large = "Large",
  Original = "Original",
}

export enum SharedModule {
  Appointment = "appointment",
  Authorisation = "authorisation",
  CalendarItem = "calendarItem",
  Customer = "customer",
  Error = "error",
  Meta = "meta",
  Profile = "profile",
  Treatment = "treatment",
  User = "user",
  Payment = "payment",
}
